(ns frontend.permissions.survey-mass-sending
  "Whether a tenant sees the cycle-driven mass sending at all.

   The batch flow - cycles, batches, reminder rules - replaces sending a
   survey process at a time, and is rolled out per tenant rather than all at
   once. A tenant without the feature keeps the paths that predate it, so
   nothing they use today disappears; they simply do not see the new entry
   points.

   One predicate rather than a feature check at each call site, so a button
   and the screen it opens cannot end up disagreeing about who is allowed to
   be there."
  (:require
   [frontend.state.current-session :as session]))

(defn enabled?
  []
  (session/has-feature-access? :feature/survey-mass-sending))
